import {collection,getDocs,query,where} from 'firebase/firestore';
import {db} from './firebase';
import {existingVideos} from './existing-videos';
import {youtubeId} from './youtube';
function playable(item){
 if(item.type==='video'&&(/^\/videos\/[a-zA-Z0-9._/-]+$/.test(item.url)||/^https:\/\/firebasestorage\.googleapis\.com\//.test(item.url))){const video=document.createElement('video');video.src=item.url;video.controls=true;video.preload='metadata';video.playsInline=true;video.setAttribute('aria-label',item.title);return video}
 if(item.type==='youtube'){
  const id=youtubeId(item.url);if(!id)return null;
  const poster=document.createElement('button');poster.type='button';poster.className='hp-youtube-poster';poster.setAttribute('aria-label',`Play ${item.title}`);
  const image=document.createElement('img');image.src=`https://i.ytimg.com/vi/${id}/hqdefault.jpg`;image.alt='';const play=document.createElement('span');play.textContent='▶';play.setAttribute('aria-hidden','true');poster.append(image,play);
  poster.addEventListener('click',()=>{const iframe=document.createElement('iframe');iframe.src=item.url+'?autoplay=1';iframe.title=item.title;iframe.allow='autoplay; encrypted-media; picture-in-picture';iframe.allowFullscreen=true;poster.replaceWith(iframe)});
  return poster;
 }
 return null;
}
export function startExistingVideoOverrides(path){
 if(!db||!existingVideos.some(row=>row.page===path))return ()=>{};
 let cancelled=false;
 getDocs(query(collection(db,'cmsVideoOverrides'),where('published','==',true))).then(snapshot=>{
  if(cancelled)return;
  const main=document.getElementById('main');if(!main)return;
  const overrides=Object.fromEntries(snapshot.docs.map(d=>[d.id,d.data()]));
  for(const row of existingVideos.filter(item=>item.page===path)){
   const saved=overrides[row.id];if(!saved)continue;
   const container=main.querySelector(row.container);if(!container)continue;
   if(saved.hidden){container.style.display='none';continue}
   const title=container.querySelector(row.label);if(title&&row.id!=='gaza-event-intro')title.textContent=saved.title;
   const old=container.querySelector(row.media);if(old)old.setAttribute('aria-label',saved.title);
   if(saved.type===row.type&&saved.url===row.url)continue;
   const replacement=playable(saved);
   if(old&&replacement)old.replaceWith(replacement);
   const watch=container.querySelector('.youtube-watch-link,a[href*="youtu.be"]');if(watch)watch.remove();
  }
 }).catch(()=>{});
 return()=>{cancelled=true};
}
